const ContractBusinessType = {
  BUSINESS: [1, 'Kinh doanh'],
  ONLINE: [2, 'Online'],
};

export default ContractBusinessType;
